const images = {
  logo: require("../assets/img/staticImage/tapsi-daroo-logo.png"),
};

export default images;
